import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Portfolio from "./components/Portfolio";
import Skills from "./components/Skills";
import Social from "./components/Social";


export default function App() {
  return (
    <>
      <Home/>
      <About />
      <Portfolio/>
      <Skills/>
      <Contact/>
      <Footer />

      <Social />
    </>
  );
}
